var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 10.4476C34.7467 10.9585 33.5234 11.2937 32.2708 11.442C33.5901 10.6525 34.5775 9.4103 35.0488 7.94678C33.8086 8.683 32.4515 9.20142 31.0364 9.47958C30.4451 8.84895 29.7306 8.34646 28.9372 8.00326C28.1438 7.66005 27.2884 7.48345 26.424 7.48438C22.9344 7.48438 20.1048 10.3132 20.1048 13.8036C20.1048 14.2984 20.1608 14.7812 20.2688 15.244C15.0168 14.9804 10.3608 12.4644 7.24396 8.64078C6.68198 9.6052 6.38669 10.7018 6.38835 11.818C6.38753 12.8584 6.64371 13.8829 7.13413 14.8004C7.62456 15.718 8.33405 16.5002 9.19955 17.0776C8.19624 17.0457 7.21503 16.7747 6.33755 16.2872C6.33675 16.3136 6.33675 16.3396 6.33675 16.3668C6.33675 19.4276 8.51476 21.9816 11.4052 22.5628C10.4745 22.8147 9.49864 22.8517 8.55155 22.6708C9.35555 25.1808 11.6892 27.0084 14.4544 27.0596C12.2159 28.8162 9.45176 29.769 6.60635 29.7648C6.09635 29.7648 5.59355 29.7352 5.09875 29.6764C7.98809 31.5328 11.3508 32.5182 14.7852 32.5148C26.4084 32.5148 32.7644 22.8864 32.7644 14.5368C32.7644 14.2632 32.758 13.99 32.746 13.7184C33.9838 12.8247 35.0519 11.7171 35.9 10.4476V10.4476Z",
    fill: "url(#paint0_linear_1048_33684)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1048_33684",
    x1: 5.09875,
    y1: 20.1315,
    x2: 37.3016,
    y2: 20.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00394562,
    stopColor: "#F44554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3271E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.52bfa6b531dd335be18f6d8fcfa41c4d.svg";
export { ForwardRef as ReactComponent };